import styled from 'styled-components';
import PropTypes from 'prop-types';

const backgroundColor = ({ color, theme }) => {
  switch (color) {
    case 'green':
      return theme.colors.semantic.lightGreen;
    case 'blue':
      return theme.colors.semantic.lightBlue;
    case 'purple':
      return theme.colors.semantic.lightPurple;
    case 'red':
      return theme.colors.semantic.lightRed;
    case 'orange':
      return theme.colors.semantic.lightOrange;
    case 'grey':
      return theme.colors.neutral.grey[0];
    case 'white':
    default:
      return theme.colors.neutral.white;
  }
};

const Container = styled.div`
  padding: 16px;
  font-family: ${({ theme }) => theme.fonts.default.fontFamily};
  border-radius: 10px;
  border:  ${({ theme, border }) => (border ? `1px solid ${theme.colors.neutral.grey[2]}` : 'none')};
  background: ${backgroundColor};
`;

Container.propTypes = {
  color: PropTypes.string,
  border: PropTypes.bool
};

export default Container;
